import React from 'react'
import { withStyles } from '@material-ui/styles';

const classes = {
    static_panel: {
        textAlign: 'center',
        padding: '1rem',
        position: 'fixed',
        zIndex: 100000,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#b14d9b',
        color: 'white'
    },
};

class LoadingScreen extends React.Component {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.static_panel} style={{ flex: 1 }}>
                <div>
                    <img src="/static/logo.png" alt="מהפח - טבע מוזנח עובר מהפך" style={{ width: '20rem', marginTop: '5rem' }}></img>
                </div>

                <div style={{marginTop:'2rem'}}>
                    <b>
                        ניקיתם בטבע? מגיע לכם קרדיט!</b>
                    <div>עדכנו באפליקציה שכולם ידעו. מצאתם שצריך לנקות ואתם לא יכולים לבד? דווחו וננסה לעזור.</div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '4rem 2rem' }}>
                    <div>
                        <img src="/static/bag_icon_2.png" alt="collect" style={{height:'8rem'}}></img>
                        <div>מביאים שקית</div>
                        
                    </div>
                    <div>
                        <img src="/static/hiking.png" alt="collect" style={{height:'8rem'}}></img>
                        <div>מטיילים ונהנים</div>
                        
                    </div>
                    <div>
                        <img src="/static/bag_icon.png" alt="collect" style={{height:'8rem'}}></img>
                        <div>אוספים ומדווחים</div>
                       
                    </div>
                </div>
                <div style={{ marginBottom: '19.5rem' }}>
                    <div>מוגש אליכם בתמיכת</div>
                    <img src="/static/wide_logo_sheli-min.png" alt="logo" style={{ width: '20rem', marginTop: '2rem' }}></img>
                </div>
            </div>
        )
    }
}

export default withStyles(classes)(LoadingScreen);